import { render, staticRenderFns } from "./PaginationCom.vue?vue&type=template&id=2a329552&scoped=true"
import script from "./PaginationCom.vue?vue&type=script&lang=js"
export * from "./PaginationCom.vue?vue&type=script&lang=js"
import style0 from "./PaginationCom.vue?vue&type=style&index=0&id=2a329552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a329552",
  null
  
)

export default component.exports